export const CONTROL_HEIGHT = {
    sm: 28,
    md: 36,
};
//# sourceMappingURL=sizing.js.map